
<template>
  <div class="container">
	 <div class="header">
      <div class="left" @click="toIndex()">< 返回</div>
      <div class="span1">
        <span> {{org_type==='area'?'武汉大学第二附属小学':'武昌区'}} 作业管理情况</span>
      </div>
      <div class="right"></div>
    </div>
    <div class="index">
    <!-- 区级 -->
    <template v-if="org_type==='area'">
      <header>
        <div class="header-item">
            <div class="flex">
                <div class="header-item-title">
                    <span class="circle"></span>
                    <span>作业备案量排行</span>
                </div>
                
                <el-radio-group v-model="radio1" class="m-l">
                        <el-radio-button label="备案数前五名"></el-radio-button>
                        <el-radio-button label="备案数后五名"></el-radio-button>
                </el-radio-group>
            </div>
            <div class="Homeboxtop_nav_tab m-t m-l">
                <span v-for="(item, index) in tabList" :class="['res-tab', { active: item.name === tabName_1 }]" :key="index" @click="tabClick_1(item)">
                    {{ item.name }}
                </span>
            </div>
			    <div class="Homeboxtop_nav_blue m-t m-l">
                <span v-for="(item, index) in list_1" :class="['res-tab', { active: item.label === scope_1 }]" :key="index" @click="tabScope_1(item)">
                    {{ item.label }}
                </span>
            </div>
            <div id="echarts-box3" class="m-t"></div>
        </div>

        <div class="header-item">
            <div class="header-item-title">
                <span class="circle"></span>
                <span>各班级作业平均完成时长</span>
            </div>
            <div class="Homeboxtop_nav_tab m-t m-l m-b">
                <span v-for="(item, index) in tabList" :class="['res-tab', { active: item.name === tabName_2 }]" :key="index" @click="tabClick_2(item)">
                    {{ item.name }}
                </span>
            </div>
			    <div class="Homeboxtop_nav_blue m-t m-l">
                <span v-for="(item, index) in list_2" :class="['res-tab', { active: item.label === scope_2 }]" :key="index" @click="tabScope_2(item)">
                    {{ item.label }}
                </span>
            </div>
            <div id="echarts-box4" class="m-t"></div>
        </div>

      </header>
      
      <div class="header-item-title m-t">
        <span class="circle"></span>
        <span>参与情况</span>
      </div>
      
      <div class="Homeboxtop_nav_tab m-t">
        <span v-for="(item, index) in tabList" :class="['res-tab', { active: item.name === tabName3 }]" :key="index" @click="tabClick3(item)">
            {{ item.name }}
        </span>
      </div>

      <!-- 表格 -->
      <el-form ref="form" :inline="true" :model="form" label-width="45px" class="m-t" >
        <el-form-item label="年级" >
          <el-input placeholder="请输入年级"></el-input>
        </el-form-item>

        <el-form-item label="" class="m-l">
          <el-button type="primary" size="small" @click="getDataList">搜索</el-button>
        </el-form-item>
      </el-form>
      <div class="table">
        <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%">
          <el-table-column align="center" prop="a" label="班级">
          </el-table-column>
          <el-table-column align="center" prop="b" label="作业登记数">
          </el-table-column>
          <el-table-column align="center" prop="c" label="作业备案总数">
          </el-table-column>
          <el-table-column align="center" prop="d" label="作业备案率">
          </el-table-column>

          <el-table-column align="center" prop="e" label="作业平均预计完成时长">
          </el-table-column>
          <el-table-column align="center" prop="f" label="作业平均完成时长">
          </el-table-column>
          <el-table-column align="center" prop="g" label="课后辅导参与学生数">
          </el-table-column>
          <el-table-column align="center" prop="h" label="课后辅导学生参与率">
          </el-table-column>
        </el-table>
      </div>
      <!--分页组件-->
      <el-pagination
        background
        :current-page="page.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.totalPage"
        layout="total,prev, pager, next,jumper,sizes"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></el-pagination>
    </template>


    <!-- 市级 -->
    <template v-else>
      <div class="header-item-title m-l">
            <span class="circle"></span>
            <span>基本情况</span>
      </div>
      <div class="Homeboxtop_nav_tab m-t m-l ">
            <span v-for="(item, index) in tabList" :class="['res-tab', { active: item.name === tabName }]" :key="index" @click="tabClick(item)">
                {{ item.name }}
            </span>
      </div>
      <div class="header_num">
        <div class="header-item">
          <div class="header-item-smallTitle">
            <img src="./imgs/icon_1.png" alt="" /> 
            <span>学校作业公示情况</span>
          </div>
          <div class="header-item-box">
            <div class="box-right">
              <div>
                <p class="box-blue">{{num_1}}</p>
                <p class="w_100">参与备案学校<br/>总数</p>
              </div>
              <div>
                <p class="box-blue mr">{{num_2}}%</p>
                <p>参与率</p>
              </div>
            </div>
          </div>
        </div>
        <div class="header-item">
          <div class="header-item-smallTitle">
            <img src="./imgs/icon_1.png" alt="" /> 
            <span>学校课后辅导情况</span>
          </div>
          <div class="header-item-box">
            <div class="box-right">
              <div>
                <p class="box-blue">{{num_3}}</p>
                <p class="w_100">参与课后辅导<br/>学校总数</p>
              </div>
              <div>
                <p class="box-blue mr">{{num_4}}%</p>
                <p>参与率</p>
              </div>
            </div>
          </div>
        </div>

        <div class="header-item">
          <div class="header-item-smallTitle">
            <img src="./imgs/icon_1.png" alt="" /> 
            <span>学校作业反馈情况</span>
          </div>
          <div class="header-item-box">
            <div class="box-right">
              <div>
                <p class="box-blue">{{num_5}}</p>
                <p>收到家长作业<br/> 反馈学校总数</p>
              </div>
              <div>
                <p class="box-blue mr">{{num_6}}%</p>
                <p>参与率</p>
              </div>
            </div>
          </div>
        </div>

      </div>

      <header>
        <div class="header-item">
            <div class="flex">
                <div class="header-item-title">
                    <span class="circle"></span>
                    <span>作业备案数情况统计</span>
                </div>
                
                <el-radio-group v-model="radio_1" class="m-l">
                        <el-radio-button label="备案数前十名"></el-radio-button>
                        <el-radio-button label="备案数后十名"></el-radio-button>
                </el-radio-group>
            </div>
            <div class="Homeboxtop_nav_tab m-t m-l m-b">
                <span v-for="(item, index) in tabList" :class="['res-tab', { active: item.name === tabName_1 }]" :key="index" @click="tabClick_1(item)">
                    {{ item.name }}
                </span>
            </div>
          
            <div id="echarts-box5" class="m-t"></div>
        </div>

        <div class="header-item">
            <div class="header-item-title">
                <span class="circle"></span>
                <span>各校作业平均完成时长前十</span>
            </div>
            <div class="Homeboxtop_nav_tab m-t m-l m-b">
                <span v-for="(item, index) in tabList" :class="['res-tab', { active: item.name === tabName_2 }]" :key="index" @click="tabClick_2(item)">
                    {{ item.name }}
                </span>
            </div>
            <div id="echarts-box6" class="m-t"></div>
        </div>

      </header>
      
      <div class="header-item-title m-t">
        <span class="circle"></span>
        <span>实施情况</span>
      </div>
      
      <div class="Homeboxtop_nav_tab m-t">
        <span v-for="(item, index) in tabList" :class="['res-tab', { active: item.name === tabName3 }]" :key="index" @click="tabClick3(item)">
            {{ item.name }}
        </span>
      </div>

      <!-- 表格 -->
      <el-form ref="form" :inline="true" :model="form" label-width="70px" class="m-t" >
        <el-form-item label="学校名称" >
          <el-input placeholder="请输入学校名称"></el-input>
        </el-form-item>

        <el-form-item label="" class="m-l">
          <el-button type="primary" size="small" @click="getDataList">搜索</el-button>
        </el-form-item>
      </el-form>
      <div class="table">
        <el-table ref="multipleTable" :data="tableData_1" tooltip-effect="dark" style="width: 100%">
          <el-table-column align="center" prop="a" label="学校">
          </el-table-column>
          <el-table-column align="center" prop="b" label="作业登记数">
          </el-table-column>
          <el-table-column align="center" prop="c" label="作业备案总数">
          </el-table-column>
          <el-table-column align="center" prop="d" label="作业备案率">
          </el-table-column>

          <el-table-column align="center" prop="e" label="作业平均预计完成时长">
          </el-table-column>
          <el-table-column align="center" prop="f" label="作业平均完成时长">
          </el-table-column>
          <el-table-column align="center" prop="g" label="课后辅导参与学生数">
          </el-table-column>
          <el-table-column align="center" prop="h" label="课后辅导学生参与率">
          </el-table-column>
        </el-table>
      </div>
      <!--分页组件-->
      <el-pagination
        background
        :current-page="page.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.totalPage"
        layout="total,prev, pager, next,jumper,sizes"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></el-pagination>
    </template>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  props:['info'],
  components: {

  },
  data() {
    return {
      num_1:63,
      num_2:85,
      num_3:70,
      num_4:94,
      num_5:35,
      num_6:47,
      tableData_1: [
        {a:'武汉大学第二附属小学',b:'4021',c:'3560',d:'89%',e:'60分钟',f:'55分钟',g:'1280',h:'71%'},
        {a:'湖北省武昌水果湖第二小学',b:'3121',c:'3560',d:'79%',e:'50分钟',f:'55分钟',g:'1280',h:'68%'},
        {a:'武汉市南湖第二小学',b:'3521',c:'2560',d:'75%',e:'50分钟',f:'55分钟',g:'1280',h:'88%'},
        {a:'武汉市武昌区复兴路小学',b:'3221',c:'2560',d:'72%',e:'55分钟',f:'55分钟',g:'1280',h:'68%'},

        {a:'湖北省武昌水果湖第一小学',b:'4521',c:'2960',d:'70%',e:'50分钟',f:'55分钟',g:'1280',h:'77%'},
        {a:'武汉市武昌区千家街小学',b:'4221',c:'3360',d:'77%',e:'55分钟',f:'55分钟',g:'1280',h:'66%'},
        {a:'武汉大学附属小学',b:'5021',c:'2560',d:'82%',e:'55分钟',f:'55分钟',g:'1280',h:'70%'},

        {a:'武汉市中华路小学',b:'3121',c:'2960',d:'90%',e:'50分钟',f:'55分钟',g:'1280',h:'66%'},
        {a:'武汉市武昌区余家头小学',b:'3221',c:'3560',d:'85%',e:'50分钟',f:'55分钟',g:'1280',h:'60%'},
        {a:'武汉市武昌区红岭小学',b:'2921',c:'2560',d:'77%',e:'55分钟',f:'55分钟',g:'1280',h:'59%'},
      ],
      radio_1:'备案数前十名',
      city_tu_1:{
        name:['武汉小\n学','武汉市\n武昌实\n验小学','武汉大\n学第二\n附属小\n学','湖北省\n武昌水\n果湖第\n二小学','武汉大\n学附属\n小学','武汉市\n中华路\n小学','湖北省\n武昌水\n果湖第\n一小学','武汉市\n南湖第\n二小学','武汉市\n武昌区\n复兴路\n小学','武汉市\n武昌区\n棋盘街\n小学'],
        list:[2560,2510,2500,2500,2499,2488,2360,2233,2122,2000],
      },
      city_tu_2:{
        name:['武汉市\n武昌区\n八辅街\n小学','武汉市\n三道街\n小学','武汉市\n武昌区\n昙华林\n小学','湖北省\n武昌水\n果湖第\n二小学','武汉市\n梅苑学\n校小学\n部','武汉市\n武昌区\n千家街\n小学','武汉市\n南湖第\n一小学','武汉市\n梨园小\n学','武汉市\n武昌区\n余家头\n小学','武汉市\n武昌区\n红岭小\n学'],
        list:[95,94,84,83,80,79,60,59,55,55,53],
      },
      city_tu_1_all:{
        '备案数前十名':{
          name:['武汉小\n学','武汉市\n武昌实\n验小学','武汉大\n学第二\n附属小\n学','湖北省\n武昌水\n果湖第\n二小学','武汉大\n学附属\n小学','武汉市\n中华路\n小学','湖北省\n武昌水\n果湖第\n一小学','武汉市\n南湖第\n二小学','武汉市\n武昌区\n复兴路\n小学','武汉市\n武昌区\n棋盘街\n小学'],
          list:[2560,2510,2500,2500,2499,2488,2360,2233,2122,2000],
        },
        '备案数后十名':{
          name:['武汉小\n学','武汉市\n武昌实\n验小学','武汉大\n学第二\n附属小\n学','湖北省\n武昌水\n果湖第\n二小学','武汉大\n学附属\n小学','武汉市\n中华路\n小学','湖北省\n武昌水\n果湖第\n一小学','武汉市\n南湖第\n二小学','武汉市\n武昌区\n复兴路\n小学','武汉市\n武昌区\n棋盘街\n小学'],
          list:[2560,2510,2500,2500,2499,2488,2360,2233,2122,2000],
        }
      },

      form: {
        schoolYearSemester: "",
        orgId: "",
        teacher:'',
        grade:'',
        class:'',
        class1:'',
        xk:'',
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 0,
      },

      tableData: [
        {a:'三年级1班',b:'10',c:'9',d:'75',e:'60',f:'55',g:'35',h:'71%'},
        {a:'三年级2班',b:'10',c:'9',d:'75',e:'55',f:'55',g:'30',h:'68%'},
        {a:'三年级3班',b:'10',c:'9',d:'75',e:'50',f:'45',g:'35',h:'88%'},
        {a:'三年级4班',b:'10',c:'8',d:'70',e:'55',f:'55',g:'29',h:'68%'},
        {a:'三年级5班',b:'10',c:'7',d:'65',e:'50',f:'46',g:'30',h:'77%'},
		    {a:'三年级6班',b:'10',c:'7',d:'65',e:'50',f:'55',g:'30',h:'61%'},
        {a:'三年级7班',b:'10',c:'7',d:'65',e:'45',f:'55',g:'28',h:'58%'},
        {a:'三年级8班',b:'10',c:'6',d:'55',e:'50',f:'45',g:'25',h:'58%'},
        {a:'三年级9班',b:'10',c:'6',d:'50',e:'55',f:'55',g:'24',h:'58%'},
        {a:'三年级10班',b:'10',c:'5',d:'45',e:'50',f:'46',g:'20',h:'47%'},
      ],
      list_1:[{id:'03',label:'学科'},{id:'04',label:'班级'},],
      list_2:[{id:'03',label:'三年级'},{id:'04',label:'四年级'},{id:'05',label:'五年级'},{id:'06',label:'六年级'},],
      scope_1:'学科',
      scope_2:'三年级',
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList"))||[],
      userInfo:JSON.parse(sessionStorage.getItem('userInfo')),
      detail: {
        info: {},
        show: false,
        show_1:false,
        show_2:false,
      },
      radio1:'备案数前五名',
      tabList: [{ name: "本周" }, { name: "本月" },{ name: "本学期" }, { name: "本年度" },],
      tabName:'本周',
      tabName1:'本周',
      tabName2:'作业被驳回频次统计',
      tabName3:'本周',

      tu_1:{
        name:['四年级3班','六年级1班','三年级2班','二年级1班','五年级2班',],
        list:[30,28,26,25,20,],
      },
      tu_2:{
        name:['三年级1班','三年级2班','三年级3班','三年级4班','三年级5班',],
        list:[95,94,84,83,80,],
      },
      tabName_1:'本周',
      tabName_2:'本周',
    };
  },
  watch:{
    info: {
      handler: function () {
        // this.getDataList();
      },
      deep: true,
    },
    radio_1(n, o){
      this.city_tu_1 = this.city_tu_1_all[n];
      this.init_1();
    }
  },
  computed:{
		// 教育局级别判断	省级:99  市级:1,10  区县级:2,20,4,40
		org_type(){
			let str = 'area';
			if(sessionStorage.getItem("user_level") === "99"){
				str = 'p'
			}
			if(["1", "10"].indexOf(sessionStorage.getItem("user_level")) > -1){
				str = 'city'
			}
			return str;
		},
	},
  mounted() {
    if(this.org_type==='area'){
      this.init();
    }else{
      this.init_1();
    }
  },
  created(){

  },
  methods: {
    tabClick(item) {
	  this.tabName = item.name;
    },
    tabClick_1(item) {
	  this.tabName_1 = item.name;
    },
    tabClick_2(item) {
	  this.tabName_2 = item.name;
    },
    tabClick1(item) {
	  this.tabName1 = item.name;
    },
    tabClick2(item) {
	   this.tabName2 = item.name;
    },
    tabClick3(item) {
	 this.tabName3 = item.name;
    },
    async getDataList() {

    },
	tabScope_1(item){
		this.scope_1=item.label;
	},
	tabScope_2(item){
		this.scope_2=item.label;
	},
    searchFun(){
      this.page.pageNum=1;
		this.getDataList();
    },
    sizeChangeHandle(val) {
      this.page.pageNum=1
      this.page.pageSize = val;
      this.getDataList()
    },

    currentChangeHandle(val) {
      this.page.pageNum=1
      this.page.pageNum = val;
      this.getDataList()
    },
    toDetail(scope) {
      console.log(scope);
      this.detail.info = scope.row;
      this.detail.show = true;
    },
    toDetail_1(scope) {
      console.log('详情1')
      this.detail.show_1 = true;
    },
    toDetail_2(scope) {
      console.log('详情2')
      this.detail.show_2 = true;
    },
	  toIndex() {
      this.$emit("to-index");
    },
    init(){
      let vm = this;
      this.$nextTick(() => {
        // 柱状图
        let chartDom1 = document.getElementById('echarts-box3');
        let myChart1 = echarts.init(chartDom1);
        let option1 = {
          grid: {
            height: 200,
            top: 20,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: vm.tu_1.name,
            // splitLine: {show: false},//去除网格分割线
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: vm.tu_1.list,
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    // { offset: 0, color: '#009DFD' },
                    { offset: 1, color: '#5BB0FF' },
                  ]),
                  // barBorderRadius: 16, // 柱子圆角, 单位为px
                  label: {
                    formatter: "{c}",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999"
                    }
                  },
                },
                
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart1.setOption(option1);

        // 柱状图
        let chartDom2 = document.getElementById('echarts-box4');
        let myChart2 = echarts.init(chartDom2);
        let option2 = {
          grid: {
            height: 200,
            top: 20,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: vm.tu_2.name,
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
					data: [75, 72, 69, 65, 60,],
					type: 'bar',
					showBackground: true,
					backgroundStyle: {
						// 背景颜色
						color: 'none', //'#E8F6FF'
					},
					itemStyle: {
						// 柱子颜色
						normal: {
						color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
							// { offset: 0, color: '#009DFD' },
							{ offset: 1, color: '#33B1FF' },
						]),
						label: {
							formatter: "{c}",
							show: true,
							position: "top",
							textStyle: {
								// fontWeight: "bolder",
								fontSize: "12",
								color: "#999999"
							}
						},
						// barBorderRadius: 16, // 柱子圆角, 单位为px
						},
					},
					barWidth: 20, //设置柱子宽度，单位为px
			},
			{
					data: [66, 66, 60, 50, 45,],
					type: 'bar',
					showBackground: true,
					backgroundStyle: {
						// 背景颜色
						color: 'none', //'#E8F6FF'
					},
					itemStyle: {
						// 柱子颜色
						normal: {
						color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
							{ offset: 1, color: '#00DAA3' },
						]),
						label: {
							formatter: "{c}",
							show: true,
							position: "top",
							textStyle: {
								fontSize: "12",
								color: "#999999"
							}
						},
						},
					},
					barWidth: 20, //设置柱子宽度，单位为px
			},
          ],
        };
        myChart2.setOption(option2);
      });
    },
    init_1(){
      let vm = this;
      this.$nextTick(() => {
        // 柱状图
        let chartDom1 = document.getElementById('echarts-box5');
        let myChart1 = echarts.init(chartDom1);
        let option1 = {
          grid: {
            height: 200,
            top: 20,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: vm.city_tu_1.name,
            // splitLine: {show: false},//去除网格分割线
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: vm.city_tu_1.list,
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    // { offset: 0, color: '#009DFD' },
                    { offset: 1, color: '#5BB0FF' },
                  ]),
                  // barBorderRadius: 16, // 柱子圆角, 单位为px
                  label: {
                    formatter: "{c}",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999"
                    }
                  },
                },
                
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart1.setOption(option1);

        // 柱状图
        let chartDom2 = document.getElementById('echarts-box6');
        let myChart2 = echarts.init(chartDom2);
        let option2 = {
          grid: {
            height: 200,
            top: 20,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: vm.city_tu_2.name,
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: vm.city_tu_2.list,
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: '#00DAA3' },
                  ]),
                  label: {
                    formatter: "{c}",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999"
                    }
                  },
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart2.setOption(option2);
      });
    },
  },
};
</script>
<style scoped>
.el-range-editor {
  width: 120%;
}
.el-range-editor >>> .el-range-separator {
  width: 8%;
}
::v-deep .el-form .el-input__inner {
  width: 189px;
  height: 32px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}

::v-deep .el-table__header tr th {
  background: #f7f7f7;
  box-shadow: 0px 1px 0px #eaeaea;
}

::v-deep .el-date-editor .el-range-separator {
  line-height: 22px;
}
</style>

<style lang="less" scoped>
.header {
    height: 60px;
    line-height: 48px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .span1 {
      font-family: "PingFang SC Bold";
      font-size: 20px;
      color: #000;
      margin-right: 30px;
    }
    .left,
    .right {
      width: 60px;
    }
    .left {
      cursor: pointer;
    }
}
.Homeboxtop_nav_tab{
    span{
        padding-bottom: 15px;
    }
}
.container {
  width: 100%;
  height: 100%;
  padding: 0 0 2% 2%;
}
.query {
  position: relative;
  margin-bottom: 2%;
}
.searchBtn {
  position: absolute;
  top: 50%;
  right: 5%;
}
.el-pagination {
  margin: 20px 0;
  padding-bottom: 30px;
  text-align: center;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 10px;
  span {
    font-family: "PingFang SC Bold";
    font-weight: bold;
    font-size: 20px;
    text-align: left;
    color: #000;
  }
}
.header-item-title{
    font-size: 18px;
    color: #333;
    display: flex;
    align-items: center;
    .circle{
        width: 8px;
        height: 8px;
        display: inline-block;
        background: #4991e1;
        border-radius: 50%;
        margin-right: 10px;
    }
}
header{
    width: 100%;
    height: 390px;
    display: flex;
    .header-item{
      width: 50%;
      .header-item-text{
        font-size: 14px;
        color: #666;
        padding-left: 20px;
        margin-top: 5px;
      }
    }
    #echarts-box3, #echarts-box4{
      width:500px;
      height:280px;
    }
}
#echarts-box5, #echarts-box6{
  width:590px;
  height:300px;
}
::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner{
    color: #409EFF;
    background: #ffffff;
}
::v-deep .el-radio-button .el-radio-button__inner{
    height: 32px;
    padding: 8px;
    color: #999999;
}
.m-l{
    margin-left: 20px;
}
.m-t{
    margin-top: 20px;
}
.m-b{
    margin-bottom: 20px;
}
.flex{
    display: flex;
    align-items: center;
}

.Homeboxtop_nav_blue{
	span{
		font-size: 14px;
		margin-right: 15px;
		border-radius: 13px;
		padding: 5px 10px;
		cursor: pointer;
	}
	.active{
		
		background: #4991e1;
    	color: #fff;
	}
}
.header_num {
    width: 100%;
    height: 200px;
    display: flex;
    .header-item {
      width: calc(33% - 50px);
      border: 1px solid #eee;
      text-align: center;
      margin-right: 50px;
      margin-bottom: 20px;
      padding: 20px;
      .bigTitle {
        font-weight: bold;
        font-size: 48px;
        color: #fff;
      }
      .cont {
        font-size: 18px;
        color: #fff;
      }
      .header-item-smallTitle {
        display: flex;
        align-items: center;
        font-size: 18px;
        height: 22px;
        color: #333;
        margin: 20px 30px;
        img {
          width: 30px;
          height: 30px;
          margin-right: 10px;
        }
      }
      .header-item-box {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 10px;
        .box-right {
          display: flex;
          justify-content: center;
          .mr {
            margin-right: 60px;
          }
          div {
            margin-left: 10px;
          }
          p {
            width: 100%;
            font-size: 14px;
            text-align: center;
            color: #999;
          }
          .box-blue {
            font-weight: bold;
            margin-bottom: 5px;
            font-size: 20px;
            color: #4794e8;
          }
        }
      }
    }
  }
  .flex{
      display: flex;
      align-items: center;
  }
</style>
